<template>
  <v-layout>
    <div class="col">
      <div class="head-page-title hide-for-small-only">
        <h1 class="main-title">Welkom!</h1>
      </div>
      <div class="panel">
        <div class="overview-content">
          <p>
            Welkom in uw MijnArrivaZakelijk omgeving,<br>
            <br>
            In deze omgeving heeft u onder andere de mogelijkheid om gegevens te beheren, uw facturen op te vragen en specificaties te downloaden. Zo houdt u overzicht en dat is een Goede Zaak! Mocht u vragen of opmerkingen hebben dan kunt u contact opnemen met onze Zakelijke Klantenservice, telefonisch via 088 277 7272 of door een e-mail te sturen naar <a href="mailto:klantenservice.zakelijk@arriva.nl">klantenservice.zakelijk@arriva.nl</a>.
          </p>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
import VLayout from '../layouts/Default'

export default {
  name: 'WelcomePage',
  components: {
    VLayout
  }
}
</script>



// WEBPACK FOOTER //
// src/views/WelcomePage.vue